// Vuex salesServicesPointsRequests module actions
import { togglePendingStoreActions } from '@/utils/decorators';
import { hParseToFilterCriteriaObjectRequiredByApi } from '@/utils/helpers';
import { API } from '@/config';

import { FILL_LIST, SET_FILTERING_CRITERIA, SET_PAGE } from './mutations-types';

export default {
  @togglePendingStoreActions('users')
  async getList({ state, commit }) {
    try {
      const params = {
        filtering_criteria: hParseToFilterCriteriaObjectRequiredByApi(state.filteringCriteria),
        page: state.list.page,
      };
      const { records, total } = (await API.get('/users/getList', { params })).data.data;
      commit(FILL_LIST, { records, total });
    } catch (err) {
      console.log(err);
    }
  },

  filterList({ state, commit, dispatch }, { key, value, label, name }) {
    try {
      const filterCriteria = { ...state.filteringCriteria };
      if (value !== null) {
        filterCriteria[key] = {
          value,
          name,
          label,
        };
      } else {
        delete filterCriteria[key];
      }
      commit(SET_FILTERING_CRITERIA, { ...filterCriteria });
      commit(SET_PAGE, { page: 1 });
      dispatch('getList');
    } catch (err) {
      console.log(err);
    }
  },

  clearFilteringCriteria({ commit }) {
    commit(SET_FILTERING_CRITERIA, {});
    commit(SET_PAGE, { page: 1 });
  },

  changePage({ commit, dispatch }, page) {
    commit(SET_PAGE, { page });
    dispatch('getList');
  },
};
